import type { StepConfig } from "@portal/components/multiform/types";
import type { AccountCreateFormData } from "../../schema";
import { AdditionalInfoStep } from "./AdditionalInfoStep";
import { AdditionalInfoSummary } from "./AdditionalInfoSummary";

export const additionalInfoStepConfig: StepConfig<AccountCreateFormData> = {
	name: "additionalInfo",
	label: "Additional Info",
	fieldPaths: ["account.additionalInfo"],
	component: AdditionalInfoStep,
	summaryComponent: AdditionalInfoSummary,
};
